<div class="card">
    <div class="card-header">
        <h5>Tags</h5>
    </div>
    <div class="card-body">
        <ul class="list-group scrollable" style="height: 368px;">
            <li *ngFor="let tag of tags()" class="list-group-item list-group-item-action cursor-pointer" (click)="openTagModal(tag)">
                <div class="d-flex">
                    <div class="d-flex flex-column">
                        <strong>{{tag.value}}</strong>
                        @if (tag.isDisplayedOnSchedule) {
                            <small class="text-muted">Displayed on Schedule</small>
                        } @else {
                            <small class="text-muted">Not Displayed on Schedule</small>
                        }
                    </div>
                    <span class="ms-auto my-auto" style="width: 48px; height: 24px; border: 1px solid gray; border-radius: 3px;" [style.background-color]="tag.hexColor ?? '#000'"></span>
                </div>
            </li>
            <li *ngIf="tags().length === 0" class="list-group-item">No Tags</li>
        </ul>
    </div>
</div>

<!-- Tags Modal -->
<ng-template #TAG_MODAL let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Edit Tag</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="tagForm">
            <div class="mb-3">
                <label for="TAG_VALUE">Value</label>
                <input id="TAG_VALUE" type="text" class="form-control" formControlName="tagValue" placeholder="Late Removal" required />
            </div>
            <div class="mb-3">
                <label for="TAG_COLOR">Color</label>
                <input id="TAG_COLOR" type="color" class="form-control" formControlName="tagColor" />
            </div>
            <div class="form-check">
                <input id="IS_DISPLAYED_ON_SCHEDULE" type="checkbox" class="form-check-input" formControlName="tagIsDisplayedOnSchedule" />
                <label for="IS_DISPLAYED_ON_SCHEDULE" class="form-check-label">Display on Schedule</label>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" [disabled]="!tagForm.valid" (click)="updateTag();">Save</button>
        <button type="button" class="btn btn-danger" (click)="openDeleteTagConfirmationModal();">Delete</button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss();">Cancel</button>
    </div>
</ng-template>